import React from 'react'
import { StatsigProvider } from 'statsig-react'
import { useAuth } from './auth/Auth.hook'

const StatsigComponent = ({ children }) => {
  const { userInfo } = useAuth()

  if (!userInfo?.user && !userInfo?.user?.id) {
    return <>{children}</>
  }
  const userStatsing = {
    userID: `${userInfo.user.id}`,
    email: userInfo.user.email,
    custom: {
      clientId: `${userInfo.user.clientId}`,
      clientName: userInfo.user.client.name,
      role: userInfo.user.role.name
    }
  }
  const optionStatsing = {
    environment: { tier: `${process.env.REACT_APP_ENV}` },
    initTimeoutMs: 5000
  }
  return (
    <StatsigProvider
      sdkKey={process.env.REACT_APP_KEY_STACKSING}
      user={userStatsing}
      options={optionStatsing}
      waitForInitialization={true}
    >
      {children}
    </StatsigProvider>
  )
}

export default StatsigComponent
